import {Component, inject, Input, NgZone, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {PrimaryButtonComponent} from "@cybfed/shared/components/primary-button/primary-button.component";
import {TranslateModule} from "@ngx-translate/core";
import {RouterModule} from "@angular/router";
import {HeroBannerComponent} from "@cybfed/new-ui/components/banners/home-banners/hero-banner/hero-banner.component";
import {NgForOf} from "@angular/common";
import {FadeInOnScrollDirective} from "@cybfed/core/helpers/fade-in-on-scroll.directive";
import {ButtonComponent} from "@white-label/components/white-label/button/button.component";
import { customSetTimeout} from "@cybfed/core/helpers/overrided-timers";
import {CarouselModel} from "@white-label/components/page-builder/models/carousel.model";
import {MainStoreService} from "@cybfed/core/store/main.store.service";

@Component({
    selector: 'app-hero-slider-banner',
    standalone: true,
    imports: [
        PrimaryButtonComponent,
        TranslateModule,
        RouterModule,
        HeroBannerComponent,
        NgForOf,
        FadeInOnScrollDirective,
        ButtonComponent
    ],
    providers: [],
    templateUrl: './hero-slider-banner.component.html'
})
export class HeroSliderBannerComponent  {
    @Input() componentModel: CarouselModel = new CarouselModel();
    currentSlide = 0;

    constructor(public mainStore: MainStoreService) {
        inject(NgZone).runOutsideAngular(() => {
            this.timer();
        });
    }

    timer(){
        customSetTimeout(() => {
            this.currentSlide++;
            if (this.currentSlide > this.componentModel.banners.value.length - 1) {
                this.currentSlide = 0;
            }
            if(this.componentModel.duration){
                this.timer()
            }
        }, this.componentModel.duration.value * 1000)
    }
    nextSlide() {
        this.currentSlide = (this.currentSlide + 1) % this.componentModel.banners.value.length;
    }

    prevSlide() {
        this.currentSlide = (this.currentSlide - 1 + this.componentModel.banners.value.length) % this.componentModel.banners.value.length;
    }

    goToSlide(index: number) {
        this.currentSlide = index;
    }
}
